/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permission_Filter_OverriddenInputs */

const fr_permission_filter_overridden = /** @type {(inputs: Permission_Filter_OverriddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surchargé`)
};

/**

* @param {Permission_Filter_OverriddenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const permission_filter_overridden = /** @type {((inputs?: Permission_Filter_OverriddenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permission_Filter_OverriddenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_permission_filter_overridden(inputs)
});